if (!customElements.get('fred-text-clamp')) {
  /**
   * Tronque un texte sur mobile (coupe nette par line-clamp, « … » collé au dernier mot)
   * et ajoute un bouton « More » / « Less » pour afficher le texte complet.
   * La coupe est faite en CSS (fred-text.liquid) ; ce composant détecte le débordement
   * et gère le dépliage.
   */
  class FredTextClamp extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.fred-text-clamp__content');
      if (!this.content || this.button) return;

      this.button = document.createElement('button');
      this.button.type = 'button';
      this.button.className = 'fred-text-clamp__toggle';
      this.label = document.createElement('span');
      this.label.className = 'fred-text-clamp__label';
      this.label.textContent = this.dataset.more ?? '';
      this.button.append(this.label);
      this.button.insertAdjacentHTML(
        'beforeend',
        '<svg class="fred-text-clamp__chevron" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 5l4 4 4-4"/></svg>'
      );
      this.button.setAttribute('aria-expanded', 'false');
      this.button.addEventListener('click', () => this.toggle());
      this.append(this.button);

      this.setAttribute('data-collapsed', '');
      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this);
      this.measure();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    toggle() {
      const collapsed = this.toggleAttribute('data-collapsed');
      this.label.textContent = (collapsed ? this.dataset.more : this.dataset.less) ?? '';
      this.button.setAttribute('aria-expanded', String(!collapsed));
    }

    measure() {
      // Replié : le texte est-il tronqué ? Déplié : le bouton « Less » reste visible.
      if (!this.hasAttribute('data-collapsed')) return;
      const target = this.content.firstElementChild;
      if (!target) return;
      const truncated = target.scrollHeight - target.clientHeight > 2;
      this.toggleAttribute('data-overflow', truncated);
    }
  }

  customElements.define('fred-text-clamp', FredTextClamp);
}
